import { fetchConsultorias, fetchControlActividades, getEstadosConsultorias } from '../services/index.service';

export default {
  namespaced: true,
  state: {
    actividades: [],
    estadosActividades: [],
    estadoActividadesStyles: {},
    entregables: [],
    consultoriaActual: null,
    prorrogas: [],
    tieneProrrogas: false,
    bitacora: [],
    meta: { current_page: 1, per_page: 5, total: 0, last_page: 1 },
    // Filtros comunes
    buscar: '',
    estadoSeleccionado: null,
  },

  getters: {
    getActividades: state => {
      return state.actividades;
    },
    getEstadoActividades: state => {
      return state.estadosActividades;
    },
    getEstadoActividadesStyles: state => {
      return state.estadoActividadesStyles;
    },
    getEntregables: state => state.entregables,
    getProrrogas: state => state.prorrogas,
    getTieneProrrogas: state => state.tieneProrrogas,
    getBitacora: state => state.bitacora,
  },
  mutations: {
    setActividades(state, items) {
      state.actividades = items;
    },
    setEstadosActividades(state, items) {
      state.estadosActividades = items;
    },
    setEstadoActividadesStyles(state, styles) {
      state.estadoActividadesStyles = styles;
    },
    setBuscar(state, value) {
      state.buscar = value;
    },
    setEstadoSeleccionado(state, estado) {
      state.estadoSeleccionado = estado;
    },
    limpiarFiltros(state) {
      state.buscar = '';
      state.estadoSeleccionado = null;
    },
    setEntregables(state, items) {
      state.entregables = items;
    },
    setConsultoriaActual(state, consultoria) {
      state.consultoriaActual = consultoria;
    },
    setProrrogas(state, prorrogas) {
      state.prorrogas = prorrogas;
    },
    setBitacora(state, bitacora) {
      state.bitacora = bitacora;
    },
    setTieneProrrogas(state, value) {
      state.tieneProrrogas = value;
    },
    setMeta(state, meta) {
      state.meta = meta;
    },
  },
  actions: {
    async fetchActividades({ commit }, payload = {}) {
      this.commit('utils/setLoader', true, { root: true });
      commit('setActividades', []);
      try {
        const { data } = await fetchConsultorias(payload);
        const responseData = data?.data ?? {};
        const consultorias = responseData.consultorias || [];
        const styles = {};
        const items = consultorias.map(c => {
          const [inicio, fin] = (c.vigencia || '').split(' - ');
          if (c.estado) {
            styles[c.estado.nombre] = {
              background: c.estado.color_bg,
              color: c.estado.color_hex,
            };
          }
          return {
            id: c.id,
            codigoSolicitud: c.codigo,
            nombreConsultoria: c.nombre,
            fechaVigencia: { inicio: inicio || '', fin: fin || '' },
            cantidadConsultores: c.consultores,
            cantidadEntregables: c.entregables,
            estado: c.estado?.nombre || '',
          };
        });
        commit('setActividades', items);
        commit('setEstadoActividadesStyles', styles);
        if (responseData.meta) commit('setMeta', responseData.meta);
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },
    async fetchEstadosActividades({ commit }) {
      this.commit('utils/setLoader', true, { root: true });
      commit('setEstadosActividades', []);
      try {
        const { data } = await getEstadosConsultorias();
        const lista = data?.data ?? [];
        const estados = [
          { nombre: 'Seleccionar', valor: null },
          ...lista.map(e => ({ nombre: e.nombre, valor: e.id })),
        ];
        commit('setEstadosActividades', estados);
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },
    setEstadoSeleccionado({ commit }, estado) {
      commit('setEstadoSeleccionado', estado);
    },
    async fetchEntregables({ commit }, idConsultoria) {
      this.commit('utils/setLoader', true, { root: true });
      commit('setEntregables', []);
      commit('setConsultoriaActual', null);
      commit('setProrrogas', []);
      commit('setTieneProrrogas', false);
      commit('setBitacora', []);
      try {
        const { data } = await fetchControlActividades(idConsultoria);
        const responseData = data?.data ?? {};
        commit('setConsultoriaActual', responseData.consultoria ?? null);
        commit('setTieneProrrogas', responseData.tiene_prorrogas ?? false);
        commit('setProrrogas', (responseData.prorrogas ?? []).map(p => ({
          entregableNombre: p.nombre,
          antes: p.antes,
          ahora: p.ahora,
        })));
        const entregables = (responseData.entregables ?? []).map(e => {
          const [periodoInicio, periodoFin] = (e.vigencia || '').split(' - ');
          return {
            id: e.id,
            nombre: e.nombre,
            estado: e.estado,
            periodoInicio: periodoInicio || '',
            periodoFin: periodoFin || '',
            totalConsultores: e.total_consultores,
            habilitarEvaluacion: e.habilitar_evaluacion ?? false,
            actividadesPendientes: e.actividades_pendientes ?? false,
            evaluar: e.evaluar ?? false,
            evaluacionNoFinalizada: e.evaluacion_no_finalizada ?? false,
            documento: e.documento || null,
          };
        });
        commit('setBitacora', (responseData.bitacora ?? []).map(b => ({
          jefe: b.jefe,
          perfil: b.perfil,
          entregable: b.entregable,
          fechaCierre: b.fecha_cierre,
          justificacion: b.justificacion,
          documento: b.documento || null,
        })));
        commit('setEntregables', entregables);
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },
    // filtro
    actualizarBuscar({ commit }, value) {
      commit('setBuscar', value);
    },
    // filtro
    actualizarEstado({ commit }, estado) {
      commit('setEstadoSeleccionado', estado);
    },
  },
};
